<template>
  <div>
    <div class="schedule-date-container text-center mb-5">
      <strong class="text-white" v-text="date"></strong>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
        <div style="border: solid 1px #667c8a; margin: 0px 0px 1rem 2rem;">
          <div class="schedule-date-container text-center">
            <strong class="text-white" v-text="$t('new_schedule')"></strong>
          </div>
          <div class="vx-row p-5">
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
              <label class="vs-input--label" v-text="$t('time')"></label>
              <flat-pickr v-model="scheduleFormData.time" :config="timePickerConfig" class="w-full" :placeholder="$t('time')" />
              <validation-error :model-error="scheduleFormErrors.time"></validation-error>
            </div>
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full mb-3">
              <label class="vs-input--label" v-text="$t('notification')"></label>
<!--              <v-select :options="notificationOptions" :reduce="label => label.value" :placeholder="$t('notification')" v-model="scheduleFormData.notification" class="md:mb-0" />-->
              <select v-model="scheduleFormData.notification" class="md:mb-0 vs-inputx vs-input--input normal">
                <option :key="indexOption" v-for="(option, indexOption) in notificationOptions" :value="option.value" v-text="option.label" />
              </select>
              <validation-error :model-error="scheduleFormErrors.notification"></validation-error>
            </div>
            <div class="vx-col md:w-1/1 sm:w-1/1 w-full mb-3">
              <vs-input :label="$tc('message', 0)" :placeholder="$tc('message', 0)" v-model="scheduleFormData.message" class="w-full"/>
              <validation-error :model-error="scheduleFormErrors.message"></validation-error>
            </div>
          </div>
          <div class="text-center mb-1">
            <vs-button id="addScheduleButton" class="m-2" color="primary" type="filled" @click.prevent="addPushNotification">{{ $t('save') }}</vs-button>
            <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelForm">{{ $t('cancel') }}</vs-button>
          </div>
        </div>
        <div style="border: solid 1px #667c8a; margin: 1rem 0px 5px 2rem;">
          <div class="schedule-date-container text-center">
            <strong class="text-white" v-text="$t('schedules')"></strong>
          </div>
          <div class="vx-row mb-8 vs-con-loading__container" id="pushNotificationDataContainer">
            <div class="vx-col w-full">
              <div class="mb-3">
                <vs-table hover-flat v-if="schedules && schedules.length" :data="schedules">
                  <template slot="thead">
                    <vs-th v-text="$t('time')" style="width: 90px;"></vs-th>
                    <vs-th v-text="$t('notification')"></vs-th>
                    <vs-th v-text="$tc('message', 0)"></vs-th>
                    <vs-th class="text-center" v-text="$t('action')" style="width: 80px;"></vs-th>
                  </template>
                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <flat-pickr v-model="tr.time" :config="timePickerConfig" class="w-full" />
                        <validation-error :model-error="tr.scheduleFormErrors.time"></validation-error>
                      </vs-td>
                      <vs-td>
                        <select v-model="tr.notification" class="md:mb-0 vs-inputx vs-input--input normal">
                          <option :key="indexOption" v-for="(option, indexOption) in notificationOptions" :value="option.value" v-text="option.label" />
                        </select>
<!--                        <v-select :options="notificationOptions" :reduce="label => label.value" :placeholder="$t('notification')" v-model="tr.notification" class="md:mb-0" />-->
                        <validation-error :model-error="tr.scheduleFormErrors.notification"></validation-error>
                      </vs-td>
                      <vs-td>
                        <vs-input v-model="tr.message" class="w-full"/>
                        <validation-error :model-error="tr.scheduleFormErrors.message"></validation-error>
                      </vs-td>
                      <vs-td class="text-center">
                        <div class="flex justify-center">
                          <save-button @click="updatePushNotification(indextr, tr.id)" :id="'updateScheduleButton' + tr.id"></save-button>&nbsp;
                          <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small" @click="destroyPushNotification(tr.id)"></vs-button>
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 ">
        <div style="border: solid 1px #667c8a; margin: 0px 2rem 1rem 0;">
          <div class="schedule-date-container text-center">
            <strong class="text-white" v-text="$t('new_memo')"></strong>
          </div>
          <div class="vx-row p-5">
            <div class="vx-col md:w-1/1 sm:w-1/1 w-full mb-3">
              <vs-input :label="$t('memo')" :placeholder="$t('memo')" v-model="memoFormData.message" class="w-full"/>
              <validation-error :model-error="memoFormErrors.message"></validation-error>
            </div>
          </div>
          <div class="text-center">
            <vs-button id="addMemoButton" class="m-2" color="primary" type="filled" @click.prevent="addMemo">{{ $t('save') }}</vs-button>
            <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelForm">{{ $t('cancel') }}</vs-button>
          </div>
        </div>
        <div style="border: solid 1px #667c8a; margin: 1rem 2rem 5px 0;">
          <div class="schedule-date-container text-center">
            <strong class="text-white" v-text="$t('memo')"></strong>
          </div>
          <div class="vx-row mb-8 vs-con-loading__container" id="memoDataContainer">
            <div class="vx-col w-full">
              <div class="mb-3">
                <vs-table hover-flat v-if="memos && memos.length" :data="memos">
                  <template slot="thead">
                    <vs-th v-text="$t('memo')"></vs-th>
                    <vs-th class="text-center" v-text="$t('action')" style="width: 100px;"></vs-th>
                  </template>
                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <vs-input v-model="tr.message" class="w-full"/>
                        <validation-error :model-error="tr.scheduleFormErrors.message"></validation-error>
                      </vs-td>
                      <vs-td class="text-center">
                        <div class="flex justify-center">
                          <save-button @click="updateMemo(indextr, tr.id)" :id="'updateMemoButton' + tr.id"></save-button>&nbsp;
                          <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small" @click="destroyMemo(tr.id)"></vs-button>
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Schedule from '@/models/Schedule'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  name: 'Window.Schedule.Form',
  components: {
    flatPickr
  },
  data () {
    return {
      date: '',
      schedules: [],
      memos: [],
      memoFormData: {
        date: '',
        message: ''
      },
      memoFormErrors: [],
      scheduleFormData: {
        date: '',
        time: '',
        message: '',
        notification: 0
      },
      scheduleFormErrors: [],
      timePickerConfig: {
        wrap: true,
        enableTime: true,
        noCalendar: true,
        defaultHour: 0,
        defaultMinute: 0
      },
      notificationOptions: [
        {
          label: this.$t('Exactly Time'),
          value: 0
        },
        {
          label: this.$t('Before 1 Hour'),
          value: 60
        }, {
          label: this.$t('Before 30 Minutes'),
          value: 30
        }
      ]
    }
  },
  mounted () {
    this.date = this.$route.params.date
    this.scheduleFormData.date = this.$route.params.date
    this.memoFormData.date = this.$route.params.date
    this.loadPushNotifications()
    this.loadMemos()
  },
  methods: {
    async loadPushNotifications () {
      const response = await Schedule.viewPushNotification({ date: this.date })
      this.schedules = response.data.data
    },
    cancelForm () {
      this.$windowOpenerHelper.notifyOpener('reload_notification_calendar')
      window.close()
    },
    async addPushNotification () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addScheduleButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)

          const response = await Schedule.storePushNotification(this.scheduleFormData)

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.scheduleFormData.memo = ''
          this.scheduleFormData.message = ''
          this.scheduleFormData.time = ''
          this.scheduleFormData.notification = ''

          this.$store.dispatch('setIsFormInProgress', false)
          this.$windowOpenerHelper.notifyOpener('reload_notification_calendar')
          window.close()

        }
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.scheduleFormErrors = errors.validationErrors
        this.$store.dispatch('setIsFormInProgress', false)
      }
      this.$vs.loading.close('#addScheduleButton > .con-vs-loading')
    },
    async updatePushNotification (key, id) {
      try {
        const confirm = await this.$swalHelper.warning({
          title: this.$t('schedule_update_confirmation_title'),
          confirmButton: this.$t('execution'),
          cancelButton: this.$t('cancel')
        })
        if (confirm.value) {
          this.$vs.loading({background: 'primary', color: '#fff', container: `#updateScheduleButton${ id }`, scale: 0.45})
          await Schedule.updatePushNotification(this.schedules[key])

          this.$swalHelper.success({
            title: this.$t('action_success'),
            confirmButton: this.$t('confirm')
          })

          this.schedules[key].scheduleFormErrors = {}
          this.$vs.loading.close(`#updateScheduleButton${ id } > .con-vs-loading`)
        }
      } catch (e) {
        this.schedules[key].scheduleFormErrors = e.response.data.errors
        this.$vs.loading.close(`#updateScheduleButton${ id } > .con-vs-loading`)
      }
    },
    async destroyPushNotification (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        try {
          this.$vs.loading({container: '#pushNotificationDataContainer'})

          const response = await Schedule.destroyPushNotification({ id })

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.loadPushNotifications()
          this.$windowOpenerHelper.notifyOpener('reload_notification_calendar')

          this.$vs.loading.close('#pushNotificationDataContainer > .con-vs-loading')
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    },
    async loadMemos () {
      const response = await Schedule.viewMemo({ date: this.date })
      this.memos = response.data.data
    },
    async addMemo () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addMemoButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)

          const response = await Schedule.storeMemo(this.memoFormData)

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.memoFormData.message = ''

          this.$store.dispatch('setIsFormInProgress', false)

          this.$windowOpenerHelper.notifyOpener('reload_notification_calendar')
          window.close()

        }
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.memoFormErrors = errors.validationErrors
        this.$store.dispatch('setIsFormInProgress', false)
      }
      this.$vs.loading.close('#addMemoButton > .con-vs-loading')
    },
    async updateMemo (key, id) {
      try {
        const confirm = await this.$swalHelper.warning({
          title: this.$t('schedule_update_confirmation_title'),
          confirmButton: this.$t('execution'),
          cancelButton: this.$t('cancel')
        })
        if (confirm.value) {
          this.$vs.loading({background: 'primary', color: '#fff', container: `#updateMemoButton${ id }`, scale: 0.45})
          await Schedule.updateMemo(this.memos[key])

          this.$swalHelper.success({
            title: this.$t('action_success'),
            confirmButton: this.$t('confirm')
          })

          this.memos[key].scheduleFormErrors = {}
          this.$windowOpenerHelper.notifyOpener('reload_notification_calendar')
          this.$vs.loading.close(`#updateMemoButton${ id } > .con-vs-loading`)
        }
      } catch (e) {
        this.memos[key].scheduleFormErrors = e.response.data.errors
        this.$vs.loading.close(`#updateMemoButton${ id } > .con-vs-loading`)
      }
    },
    async destroyMemo (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        try {
          this.$vs.loading({container: '#memoDataContainer'})

          const response = await Schedule.destroyMemo({ id })

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.loadMemos()
          this.$windowOpenerHelper.notifyOpener('reload_notification_calendar')

          this.$vs.loading.close('#memoDataContainer > .con-vs-loading')
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
.schedule-date-container {
  background-color: #667c8a;
  padding: 8px;
}
.flatpickr-calendar.hasTime.noCalendar {
  width: 200px !important;
}
#addScheduleButton {
  .con-vs-loading {
    position: absolute !important;
  }
}
#addMemoButton {
  .con-vs-loading {
    position: absolute !important;
  }
}
</style>
